import { isNotNullUnit, unitToString } from '../../unit';
import assertNever from '../../utils/assertNever';
import { ASTExpr } from '../ast';
import { ExprType } from '../expr_types';
import { parseExpression } from '../parser';

/**
 * Returns an ASTExpr that's as "empty" as we can make it for the provided type.
 */
export function emptyExpr(exprType: ExprType): ASTExpr {
  return parseExpression(emptyExprString(exprType));
}

export function emptyExprString(exprType: ExprType): string {
  const { ty } = exprType;
  switch (ty) {
    case 'nullable':
    case 'null':
      return 'null';
    case 'number':
      if (isNotNullUnit(exprType.unit)) {
        return `cast(0, "${unitToString(exprType.unit)}")`;
      }
      return '0';
    case 'string':
      return '""';
    case 'boolean':
      return 'false';
    case 'date':
    case 'datetime':
      return 'date("1970-01-01")';
    case 'list':
      return 'list()';
    case 'quantity':
      const unit = exprType.units[0];
      if (isNotNullUnit(unit)) {
        return `cast(0, "${unitToString(unit)}")`;
      }
      return '0';
    default:
      assertNever(ty);
  }
}
